import * as Flowbite from 'flowbite-react';
import { BaseInputProps } from 'shared/Input/types';
import { theme } from './theme';

type SliderProps = BaseInputProps<number>;

export const Slider = ({
    label,
    onChange = () => {},
    ...props
}: SliderProps) => (
    <Flowbite.Label className="flex flex-col gap-4" color={props.color}>
        <span className="block font-medium">{label}</span>
        <div className="grow">
            <Flowbite.RangeSlider
                {...props}
                theme={theme}
                onChange={(e) =>
                    !props.readOnly && onChange(Number(e.target.value))
                }
            />
        </div>
    </Flowbite.Label>
);
